export enum AgencyNewsEnum {
  CEDRO = '1',
  BOVESPA = '3',
  BMF = '4',
  ESTADO = '69',
  INVESTIMMENTOS_NOTICIA = '11'
}
